import { useMutation, useQueryClient } from '@tanstack/react-query';

import { aiIncidentsApi } from '../api/aiIncidents';
import { aiIncidentsQueryKeys } from './queryKeys';

export const useUpdateAiIncidentViewed = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: aiIncidentsApi.updateAiIncidentViewed,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: aiIncidentsQueryKeys.all });
    },
  });
};
